module.exports = __webpack_public_path__ + "img/kites.1cb489f7.png";